/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setSelectedImage, setPreviewImage, uploadCustomImage } from 'state/actions/embedsState/embedManagementState/content_status';
import { getUserImages, addTemporaryUserImage } from 'state/actions/embedsState/embedManagementState/image_status';
// component
import YourOwn from 'material/embeds/imageapi/imagepane/pane/yourown/yourown';
 


/* ========== ~~~~~~~~~~ IMAGE PANE : YOUR OWN : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState, sessionStatus }) => ({
    activeSelection: embedsState.embedManagementState.contentStatus.activeSelection, // background, questionImage, option_0, option_1, option_2, option_3
    selectedContent: embedsState.embedManagementState.contentStatus.selectedContent,
    uploadingCustomImage: embedsState.embedManagementState.contentStatus.uploadingCustomImage,
    accountUUID: sessionStatus.accountUUID, //account id used for image fetch
    provider: embedsState.embedManagementState.imageStatus.provider, 
    images: {
        data: embedsState.embedManagementState.imageStatus.images, 
        length: embedsState.embedManagementState.imageStatus.images.length
    },
    isDataReceived: embedsState.embedManagementState.imageStatus.isDataReceived,
    error: embedsState.embedManagementState.imageStatus.error,
});

const mapDispatchToProps = dispatch => ({
    setSelectedImage: (provider, imageId, imageURL) => dispatch(setSelectedImage(provider, imageId, imageURL)),// provider: USAToday, SIPA
    setPreviewImage: imageURL => dispatch(setPreviewImage(imageURL)),
    getUserImages: UUID => dispatch(getUserImages(UUID)),
    addTemporaryUserImage: imageFile => dispatch(addTemporaryUserImage(imageFile)),
    uploadCustomImage: (contentId, optionId, clientUUID, imageFile) => dispatch(uploadCustomImage(contentId, optionId, clientUUID, imageFile)) // upload image to aws
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(YourOwn);
